import React from "react";
import { cls } from "cls";
import { Specification } from "~/ProductDetails/ProductDetailPageResult";

const SpecificationField = ({
  productSpecifications,
  specificationId,
}: {
  productSpecifications: Specification[];
  specificationId: number;
}) => {
  const productSpec = productSpecifications?.find(
    (s: Specification) => s.id === specificationId,
  );

  let value = "-";

  const spec = productSpec?.types[0];
  const classification = productSpec?.classification;
  if (spec) {
    value = spec.value;
  }

  const specTypeValues = productSpec?.types.slice(0, 3).map((t) => {
    return t.value;
  });

  return (
    <li key={specificationId} className={cls("compare-row", "h-21")}>
      <div
        data-title={classification}
        className={cls("text-[15px]", "text-center")}
      >
        {classification && (
          <span className="sr-only">{`${classification}: `}</span>
        )}
        {(classification === "Color" && specTypeValues?.join(", ")) ||
          value.trim()}
        {value === "-" && (
          <span className="sr-only">specification unavailable</span>
        )}
      </div>
    </li>
  );
};

export default SpecificationField;
